import {GAMES_MENU_LOAD, GAMES_MENU_SET} from "./gameMenuActions";


export const gamesMenuReducer = (state = {current: null, list: []}, action) => {
    switch (action.type) {
        case GAMES_MENU_LOAD:
            return {
                ...state,
                list: [
                    ...state.list.filter(e => e.key.status !== action.payload.key.status || e.key.scope !== action.payload.key.scope),
                    action.payload
                ]
            };
        case GAMES_MENU_SET:
            return {
                ...state,
                current: state.list.find(e => e.key.status === action.payload.status && e.key.scope === action.payload.scope),
                showFrom: 0
            };
        default:
            return state;
    }
};